import { StyleSheet } from 'aphrodite';
import { antiFlashWhite, brandPrimaryText, white } from '../../styles/colors';
import { THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'stretch',
		background: white,
		border: `1px solid ${antiFlashWhite}`,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: 12,
		position: 'relative',
		transition: 'box-shadow 0.2s ease, transform 0.2s ease',
		marginRight: THEME.spacing.sm,
		':hover': {
			boxShadow: '0px 4px 16px rgba(139, 139, 139, 0.12)',
			transform: 'translateY(-1px)',
		},
	},
	featured: {
		position: 'relative',

		':before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: 0,
			width: 0,
			height: 0,
			borderLeft: '20px solid transparent',
			borderTop: `20px solid ${THEME.colors.hover.main}`, // Blue color for the triangle
			borderRadius: `0 ${THEME.common.borderRadius}px 0 0`, // Match the card's border radius on top-right
		},
	},
	topContainer: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
	},
	newBadge: {
		fontSize: 14,
		color: THEME.colors.tertiary.main,
		fontWeight: 600,
	},
	infoIcon: {
		width: 16,
		height: 16,
		opacity: 0.6,
		cursor: 'pointer',
		':hover': {
			opacity: 1,
		},
	},
	headerContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	titleContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	titleButton: {
		textAlign: 'left',
		background: 'none',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
		fontSize: 16,
		fontWeight: 600,
		color: brandPrimaryText,
		lineHeight: 1.5,
		height: 'fit-content',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		// @ts-expect-error - aphrodite doesn't support webkit box
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: 2,
		// Use word-wrap to prevent cutoff
		wordWrap: 'break-word',
		// Height for 2 lines with proper spacing

		':hover': {
			color: brandPrimaryText,
		},
	},
	contentContainer: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
	},
	tooltipContent: {
		maxWidth: 200,
		whiteSpace: 'normal',
		wordWrap: 'break-word',
		hyphens: 'auto',
	},
	actionsContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	infoContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.md,
	},
	copyDirectLinkContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
});
